// A larch: a conifer with sparser, ochre-tinged needles (autumn gold) and a
// more open, slightly ragged shape. Ported 1:1 from age-of-mcp's classic
// tree-larch.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.CylinderGeometry(0.05, 0.08, 0.34, 5),
      color: "#5a4326", position: [0, 0.17, 0] },
    { geometry: new THREE.ConeGeometry(0.42, 0.66, 6),
      color: "#8f9a3e", position: [0, 0.58, 0] },
    { geometry: new THREE.ConeGeometry(0.32, 0.62, 6),
      color: "#a5af4d", position: [0, 0.98, 0] },
    { geometry: new THREE.ConeGeometry(0.2, 0.56, 6),
      color: "#bcc25e", position: [0, 1.36, 0] },
  ];
}

export const treeLarch = defineModel({
  id: "tree-larch",
  batchId: "standard",
  name: "Tree larch",
  tags: ["scenery","tree","larch","low-poly","age-of-mcp","classic"],
  summary: "Low-poly tree larch.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.44,
  parts: () => partsFor(),
  animations: [],
});
